/* eslint-disable */
export default {
      "share@NATIVE_SHARING_MW_LANDING_PAGE/ACTION": 0,
      "settings@cookies.banner.accept_cta": 1,
      "settings@cookies.banner.settings_cta": 2,
      "settings@cookies.footer.cookie_policy": 3,
      "onboarding@bumble.incognito.dismiss_warning.cta.cancel": 4,
      "signin@PHONE_INCORRECT": 5,
      "corp@copyright_notice": 6,
      "bumblesite@LAYOUT.FOOTER.BUMBLE_BFF": 7,
      "bumblesite@LAYOUT.FOOTER.BUMBLE_BIZZ": 8,
      "bumblesite@LAYOUT.FOOTER.BUMBLE_DATE": 9,
      "bumblesite@LAYOUT.HEADER.ABOUT": 10,
      "bumblesite@LAYOUT.HEADER.AMBASSADORS": 11,
      "bumblesite@LAYOUT.HEADER.BEEHIVE": 12,
      "bma_client@cookie-notification.text": 13,
      "bma_client@dialog.photo_verification.not_access.download_app": 14,
      "bma_client@download_app_android": 15,
      "bma_client@download_app_ios": 16,
      "bma_client@pages.error.not-found.description": 17,
      "bma_client@pages.login-password.submit": 18,
      "bma_client@pages.registration.form.submit": 19,
      "bma_client@pages.registration.form.title": 20,
      "bma_client@video_chat.error_title": 21
} as const;
